import React from 'react';
import { string } from 'prop-types';
import '../styles/StaticPage.css';

function StaticPage({ content }) {
    return (
        <div
            className={'static-page'}>
            <div
                className={'static-page-content'}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    );
}

StaticPage.propTypes = {
    content: string,
};

export default StaticPage;